import React from 'react';

import { Text } from '@reckon-web/text';

import { GetActivityItem } from '../../data/useGetActivities';

import {
  ActivityPropertyTypeEnum,
  ActivityPropertyTypeEnumValue,
  ActivityTargetTypeEnum,
  ActivityTargetValue,
} from './activities-types';
import {
  ActivityPropertyBoolean,
  ActivityPropertyDate,
  ActivityPropertyDateTime,
  ActivityPropertyFloat,
  ActivityPropertyInt,
  ActivityPropertyJobStatus,
  ActivityPropertyJobStatusType,
  ActivityPropertyMoney,
  ActivityPropertyString,
  ActivityPropertyTaskStatus,
  ActivityPropertyUser,
} from './activity-property-types';

export const getTargetType = (activityTarget: ActivityTargetValue) =>
  ActivityTargetTypeEnum.labels[activityTarget].toLowerCase();

// NOTE: ActivityPropertyTypeEnum.EntityList and ActivityPropertyTypeEnum.Recurrence is not used.
const getActivityProperyLabel = (
  activityProperty: ActivityPropertyTypeEnumValue
) => ActivityPropertyTypeEnum.labels[activityProperty];

export const getPropertyOld = (activity: GetActivityItem) => {
  switch (
    getActivityProperyLabel(
      activity.propertyType as ActivityPropertyTypeEnumValue
    )
  ) {
    case 'Boolean':
      return <ActivityPropertyBoolean value={activity.propertyOld} />;
    case 'DateTime':
      return <ActivityPropertyDateTime value={activity.propertyOld} />;
    case 'Date':
      return <ActivityPropertyDate value={activity.propertyOld} />;
    case 'Float':
      return <ActivityPropertyFloat value={activity.propertyOld} />;
    case 'Int':
      return <ActivityPropertyInt value={activity.propertyOld} />;
    case 'JobStatus':
      return <ActivityPropertyJobStatus value={activity.propertyOld} />;
    case 'Money':
      return <ActivityPropertyMoney value={activity.propertyOld} />;
    case 'String':
      return <ActivityPropertyString value={activity.propertyOld} />;
    case 'TaskStatus':
      return <ActivityPropertyTaskStatus value={activity.propertyOld} />;
    case 'User':
      return <ActivityPropertyUser value={activity.propertyOld} />;
    case 'JobStatusType':
      return <ActivityPropertyJobStatusType value={activity.propertyOld} />;
    default:
      return <Text>Unknown PropertyType = "{activity.propertyType}"</Text>;
  }
};

export const getPropertyNew = (activity: GetActivityItem) => {
  switch (
    getActivityProperyLabel(
      activity.propertyType as ActivityPropertyTypeEnumValue
    )
  ) {
    case 'Boolean':
      return <ActivityPropertyBoolean value={activity.propertyNew} />;
    case 'DateTime':
      return <ActivityPropertyDateTime value={activity.propertyNew} />;
    case 'Date':
      return <ActivityPropertyDate value={activity.propertyNew} />;
    case 'Float':
      return <ActivityPropertyFloat value={activity.propertyNew} />;
    case 'Int':
      return <ActivityPropertyInt value={activity.propertyNew} />;
    case 'JobStatus':
      return <ActivityPropertyJobStatus value={activity.propertyNew} />;
    case 'Money':
      return <ActivityPropertyMoney value={activity.propertyNew} />;
    case 'String':
      return <ActivityPropertyString value={activity.propertyNew} />;
    case 'TaskStatus':
      return <ActivityPropertyTaskStatus value={activity.propertyNew} />;
    case 'User':
      return <ActivityPropertyUser value={activity.propertyNew} />;
    case 'JobStatusType':
      return <ActivityPropertyJobStatusType value={activity.propertyNew} />;
    default:
      return <Text>Unknown PropertyType = "{activity.propertyType}"</Text>;
  }
};
